import * as React from 'react';
// import { ApolloProvider } from '@apollo/client';
// import { MyRotaryClient } from './clients';
import { NotificationProvider } from '@use-cases/notifications/NotificationProvider';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  // @ts-ignore
  return <NotificationProvider>{element}</NotificationProvider>;
};
